import * as FormsActions from './actions/forms.actions';
import { Form } from 'src/app/models/form.model';

export type Action = FormsActions.All;

//Valor por defecto
const defaultState = {
    form: '0',
    title: ''
}

//Crear nuevo objeto de estado
const newState = (state, newData) => {
    return Object.assign({}, state, newData);
}

export function formReducer(state:Form = defaultState, action: Action){
    switch(action.type){
        case FormsActions.UPDATE_FORM:
            return newState(state, {form: action.payload, title: action.title});
        default:
            return state;
    }
}